import { Form, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const DaysSelector = ({ formData, setFormData, errors }) => {
  const days = [
    { label: "Monday", key: "monday" },
    { label: "Tuesday", key: "tuesday" },
    { label: "Wednesday", key: "wednesday" },
    { label: "Thursday", key: "thursday" },
    { label: "Friday", key: "friday" },
    // { label: "Saturday", key: "saturday" },
    // { label: "Sunday", key: "sunday" },
  ];

  const handleDayChange = (dayKey, dayLabel) => {
    const isSelected = formData.attending_days?.includes(dayLabel);

    // Add or remove the day from the attending_days array
    const updatedDays = isSelected
      ? formData.attending_days.filter((day) => day !== dayLabel)
      : [...(formData.attending_days || []), dayLabel];

    const updatedFormData = {
      ...formData,
      attending_days: updatedDays,
    };

    setFormData(updatedFormData);
  };

  return (
    <div className="mb-3">
      <div className="mb-3">
        <FormattedMessage id="preferred_days" />
      </div>
      <Row className="mb-2">
        {days.map((day) => (
          <Col xs="auto" key={day.key}>
            <Form.Check
              type="checkbox"
              label={day.label}
              name="day"
              id={`day_${day.key}`}
              checked={formData.attending_days?.includes(day.label)}
              onChange={() => handleDayChange(day.key, day.label)}
            />
            
          </Col>
        ))}
        {errors?.attending_days && (
              <Form.Group className="mb-4 position-relative">
                <Form.Control.Feedback className="px-3 d-block" type="invalid">
                  <FormattedMessage id="error.attending_days" />
                </Form.Control.Feedback>
              </Form.Group>
            )}
      </Row>
    </div>
  );
};

export default DaysSelector;
